import * as React from "react";
function SvgFunnelFilled(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={svgRef}
      {...props}
    >
      <path d="M6.8 8l-6-6h14.4l-6 6v6H6.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFunnelFilled);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
